// extracted by mini-css-extract-plugin
export default {"headline":"sUon9owpl6grFwaCkbBh","fadeIn":"cg7Pq5WNvVEGNE9kQZFo"};